import { gql } from "@apollo/client";

export const CREATE_PURCHASER = gql`
  mutation CreatePurchaser($params: CreatePurchaserInput!) {
    createPurchaser(params: $params) {
      purchaserId
      purchaserKey
      purchaserName
      purchaserIsActive
      associatedBrandsCount
      brandPurchaser {
        id
        email
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
        deletedAt
        deletedBy
      }
    }
  }
`;

export const UPDATE_PURCHASER = gql`
  mutation UpdatePurchaser($params: UpdatePurchaserInput!) {
    updatePurchaser(params: $params) {
      purchaserId
      purchaserKey
      purchaserName
      purchaserIsActive
      associatedBrandsCount
      brandPurchaser {
        id
        email
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
        deletedAt
        deletedBy
      }
    }
  }
`;

export const CREATE_BRAND_PURCHASER_ASSOCIATION = gql`
  mutation CreateBrandPurchaserAssociation($params: CreateBrandPurchaserAssociationInput!) {
    createBrandPurchaserAssociation(params: $params) {
      brandId
      brandName
      brandKey
      brandPurchaserId
      purchaserInboxEmailId
      isActive
    }
  }
`;
